import { NgModule } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { IconResolver, MatIconRegistry } from "@angular/material/icon";

@NgModule()
export class IconsModule {
    constructor(private _domSanitizer: DomSanitizer, private _matIconRegistry: MatIconRegistry) {
        this._matIconRegistry.addSvgIconSet(
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-twotone.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "mat_outline",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-outline.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "mat_solid",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-solid.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "iconsmind",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/iconsmind.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "feather",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/feather.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "heroicons_outline",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/heroicons-outline.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "heroicons_solid",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/heroicons-solid.svg")
        );

        const resolver: IconResolver = (name: string, namespace: string | null) => {
            // If a namespace is present, it means the icon should be handled by a specific set above.
            if (namespace) {
                return null;
            }
            // If no namespace is present, assume it's a unicons-line icon as a fallback.
            return this._domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/unicons-line/${name}.svg`);
        };
        this._matIconRegistry.addSvgIconResolver(resolver);
    }
}
